import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToTop = (options = { scrollToTopOnMount: true }) => {
  const { pathname } = useLocation();
  const { scrollToTopOnMount } = options;

  useEffect(() => {
    const resetScrollPositions = () => {
      window.scrollTo(0, 0);

      const scrollContainers = [
        document.querySelector(".main-box"),
        document.querySelector(".main-content-stack"),
        ...(document.querySelectorAll("[class*='MuiBox-root']") || []),
        ...(document.querySelectorAll("[class*='MuiContainer-root']") || []),
        document.querySelector("main"),
        ...(document.querySelectorAll(".disable-scrollbars") || []),
        document.body,
      ];

      scrollContainers.forEach((container) => {
        if (container && typeof container.scrollTo === "function") {
          container.scrollTo(0, 0);
        }
      });
    };

    if (scrollToTopOnMount || pathname !== "/") {
      resetScrollPositions();
    }
  }, [pathname, scrollToTopOnMount]);
};

export default useScrollToTop;
